$(document).ready(function() {
	
	$(document).on('click', '.js-vi-open', function() {
		if ($('.vi-top-control').is(":hidden")) {
			$('.vi-top-control').show();
		} else {
			$('.vi-top-control').hide();
		}
		$('body').toggleClass('visually-impaired');
	});

	$(document).on('click', '.vi-top-control__version', function() {
		$('.vi-top-control').hide();
		$('body').removeClass('visually-impaired');
	});
});


// WEBPACK FOOTER //
// ./src/js/visually-impaired/open.js